<template>
  <v-dialog
    :value="value"
    max-width="560"
    @input="close"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <div class="text-body-2 mb-3">
          <slot />
          ແຖວທີ 1 ເປັນຫົວຖັນ. ແຖວທີ່ຖືກຕ້ອງຈະຖືກສົ່ງເປັນຄຳຂໍ, ແຖວທີ່ບໍ່ຜ່ານຈະສະແດງເຫດຜົນ.
          <b>ສູງສຸດ 500 ແຖວຕໍ່ໄຟລ໌.</b>
          <a @click="$emit('download-template')">ດາວໂຫລດແບບຟອມ</a>
        </div>
        <v-file-input
          v-model="file"
          accept=".xlsx,.xls"
          outlined
          dense
          show-size
          label="ໄຟລ໌ Excel (.xlsx)"
          :error-messages="fileError"
          @change="fileError = ''"
        />
        <template v-if="result">
          <v-alert
            type="success"
            text
            dense
          >
            ສົ່ງຄຳຂໍແລ້ວ {{ result.created }} ລາຍ
          </v-alert>
          <v-alert
            v-if="result.skipped.length"
            type="warning"
            text
            dense
          >
            ຂ້າມ {{ result.skipped.length }} ແຖວ:
            <div
              v-for="s in result.skipped"
              :key="s.row"
              class="text-caption"
            >
              ແຖວ {{ s.row }} ({{ s.code || '-' }}): {{ s.message }}
            </div>
          </v-alert>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="close"
        >
          ປິດ
        </v-btn>
        <v-btn
          color="success"
          depressed
          :loading="importing"
          @click="importFile"
        >
          Import
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/** Upload an Excel sheet to `${api}/import`; shows how many requests were made and the skipped rows. */
export default {
  name: 'ExcelImportDialog',
  props: {
    value: { type: Boolean, default: false },
    api: { type: String, required: true },
    title: { type: String, default: 'Import Excel' },
  },
  data() {
    return {
      file: null, fileError: '', importing: false, result: null,
    };
  },
  methods: {
    importFile() {
      if (!this.file) {
        this.fileError = 'ກະລຸນາເລືອກໄຟລ໌';
        return;
      }
      const fd = new FormData();
      fd.append('file', this.file);
      this.importing = true;
      this.result = null;
      this.$axios
        .post(`${this.api}/import`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((res) => {
          this.result = res.data.data;
          this.file = null;
          this.$emit('imported', this.result);
        })
        .catch((error) => {
          const data = (error.response && error.response.data) || {};
          this.fileError = (data.errors && data.errors.file && data.errors.file[0]) || data.message || 'Something went wrong';
        })
        .finally(() => {
          this.importing = false;
        });
    },
    close() {
      this.result = null;
      this.file = null;
      this.fileError = '';
      this.$emit('input', false);
    },
  },
};
</script>
